export const LOADING_UPLOAD_REGULATION = 'LOADING_UPLOAD_REGULATION';
export const RECEIVE_UPLOAD_REGULATION = 'RECEIVE_UPLOAD_REGULATION';
export const ERROR_UPLOAD_REGULATION = 'ERROR_UPLOAD_REGULATION';

export const LOADING_GET_REGULATIONS = 'LOADING_GET_REGULATIONS';
export const RECEIVE_GET_REGULATIONS = 'RECEIVE_GET_REGULATIONS';
export const ERROR_GET_REGULATIONS = 'ERROR_GET_REGULATIONS';
